import { useQuery } from '@tanstack/vue-query';
import { queries } from '@/api/queries';
import { getApiV2RestaurantsAll, RestaurantObject } from '@/api/pensa';
import { Coordinates } from '@/types';
import { ObjectToCamel } from '@pasta-evangelists/pasta-types/dist/utils';

type RestaurantsAllResponse = { [key: string]: { data: ObjectToCamel<RestaurantObject>[] } };

const useGetValidStoresForAllTypes = (params: Ref<Coordinates | null>) => {
  const enabled = computed(() => !!params.value);
  return useQuery({
    ...queries.takeaway.nearestStoresForAllTypes(params),
    queryFn: async () => {
      const result = await getApiV2RestaurantsAll({
        lat: params.value!.lat,
        lon: params.value!.lon,
        nearest: true,
        available_only: false,
      });
      return result as RestaurantsAllResponse;
    },
    enabled,
  });
};

export default useGetValidStoresForAllTypes;
